import { render } from "./prescriptionSelector.vue?vue&type=template&id=5e92f882&scoped=true"
import script from "./prescriptionSelector.vue?vue&type=script&lang=js"
export * from "./prescriptionSelector.vue?vue&type=script&lang=js"

import "./prescriptionSelector.vue?vue&type=style&index=0&id=5e92f882&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e92f882"]])

export default __exports__